import { isNonNullable } from '@ori/ts-utils';

import type { BannersCarouselItem } from '../components/TopAreaBanner/components';
import { INVITATION_OFFER_HASH } from '../constants';
import type { TopAreaBannersQuery } from '../models/graphql-types/net';
import { sanitizeKey } from './sanitizeKey';

interface MapTopAreaBannersParams {
  data: TopAreaBannersQuery;
}
export const mapTopAreaBanners = ({ data }: MapTopAreaBannersParams): BannersCarouselItem[] | undefined => {
  if (!data.application?.permanentTopBanners) {
    return undefined;
  }
  const { permanentTopBanners } = data.application;

  return permanentTopBanners
    .filter(isNonNullable)
    .filter((banner) => banner.message ?? banner.link?.relativeUrl)
    .map((banner) => ({
      title: banner.message ?? '',
      shouldOpenInvitationOffer: banner.link?.relativeUrl === INVITATION_OFFER_HASH,
      url: sanitizeKey(banner.link?.relativeUrl ?? ''),
    }));
};
